<vex-page-layout>
	<div *transloco="let t">
		<vex-page-layout-header class="pb-16 flex flex-col justify-center items-start">
			<div>
				<h1 class="title mt-0 mb-1">{{ t('documentTransfer.title') }}</h1>
				<vex-breadcrumbs [crumbs]="this.breadCrumbService.crumbs"></vex-breadcrumbs>
			</div>
		</vex-page-layout-header>
		<vex-page-layout-content [class.container]="false" [class.px-gutter]="true" class="-mt-6">
			<div @stagger class="card overflow-auto -mt-16">
				<div class="card p-4">
					<div class="flex flex-row justify-start items-stretch w-full">
						<vex-file-upload [preselectedUploadType]="uploadType$ | async" (fileUploaded)="fileList.refreshList()"></vex-file-upload>
						<vex-file-list #fileList class="w-full"></vex-file-list>
					</div>
				</div>
			</div>
		</vex-page-layout-content>
	</div>
</vex-page-layout>
